import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function BackIcon() {
  const isDark = useAppSelector(isDarkTheme)
  return (
    <svg
      width='46'
      height='45'
      viewBox='0 0 46 45'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.279297'
        y='0.0166016'
        width='44.978'
        height='44.978'
        rx='2.81113'
      />
      <path
        d='M33.3107 14.0728C32.9225 14.0728 32.6079 14.3874 32.6079 14.7755V30.2367C32.6079 30.6248 32.9225 30.9395 33.3107 30.9395C33.6988 30.9395 34.0134 30.6248 34.0134 30.2367V14.7755C34.0134 14.3874 33.6988 14.0728 33.3107 14.0728ZM29.7967 22.5061C29.7967 22.118 29.4821 21.8034 29.094 21.8034H13.9239L18.3465 17.3808C18.6208 17.1064 18.6208 16.6614 18.3465 16.3869C18.072 16.1125 17.627 16.1125 17.3524 16.3869L11.7302 22.0092C11.6564 22.083 11.6024 22.1692 11.5683 22.2611C11.5399 22.3374 11.5244 22.4199 11.5244 22.5061C11.5244 22.5923 11.5399 22.6749 11.5683 22.7512C11.6024 22.8431 11.6564 22.9293 11.7302 23.0031L17.3524 28.6254C17.627 28.8998 18.072 28.8998 18.3465 28.6254C18.6208 28.3509 18.6208 27.9059 18.3465 27.6315L13.9239 23.2089H29.094C29.4821 23.2089 29.7967 22.8943 29.7967 22.5061Z'
        fill={isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'}
      />
    </svg>
  )
}
